import { UserTypeConstants } from '../../user-type-constants';
import { OmapiIdConstants } from '../../omapi-id-constants';
import { LabelConstants } from '../../label-constants';
var OmapiIdsUtils = /** @class */ (function () {
    function OmapiIdsUtils() {
    }
    OmapiIdsUtils.setUserTypeGlobally = function (jwtToken) {
        OmapiIdsUtils.currentUserType = this.parseJwt(jwtToken)[OmapiIdsUtils._BSS_SYSTEM_FLAG];
    };
    OmapiIdsUtils.setDarwinUserTypeGlobally = function (dwnType) {
        OmapiIdsUtils.currentDarwinUserType = dwnType;
    };
    OmapiIdsUtils.setCorrectConstantsGlobally = function () {
        OmapiIdsUtils.setCorrectOmapiIdConstants();
        OmapiIdsUtils.setNameMappingConstants();
        OmapiIdsUtils.setStreamzGroup();
        OmapiIdsUtils.setOrderPack();
    };
    OmapiIdsUtils.setStreamzGroup = function () {
        this.STREAMZ_PACKS_GROUP = [
            OmapiIdConstants.STREAMZ,
            OmapiIdConstants.STREAMZ_BASIC,
            OmapiIdConstants.RED_CARPET_MORE
        ];
        this.STREAMZ_FREE_ADD_PACKS_GROUP = [
            OmapiIdConstants.STREAMZ,
            OmapiIdConstants.RED_CARPET_MORE
        ];
    };
    OmapiIdsUtils.setOrderPack = function () {
        if (OmapiIdsUtils.isBusinessUser()) {
            this.ORDER_PACK = this.OrderPacksBusiness;
        }
        else {
            this.ORDER_PACK = this.OrderPacks;
        }
    };
    OmapiIdsUtils.setCorrectOmapiIdConstants = function () {
        OmapiIdConstants.TRIALS = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.TRIALS_LEGACY_ID, OmapiIdsUtils.TRIALS_DWN_RESIDENTIAL_ID, OmapiIdsUtils.TRIALS_DWN_BUSINESS_ID);
        OmapiIdConstants.BE_TV_VLA = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.BE_TV_VLA_LEGACY_ID, OmapiIdsUtils.BE_TV_VLA_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BE_TV_VLA_DWN_BUSINESS_ID);
        OmapiIdConstants.BE_TV_BXL_WAL = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.BE_TV_BXL_WAL_LEGACY_ID, OmapiIdsUtils.BE_TV_BXL_WAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BE_TV_BXL_WAL_DWN_BUSINESS_ID);
        OmapiIdConstants.BE_TV_SPORT_VLA = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.BE_TV_SPORT_VLA_LEGACY_ID, OmapiIdsUtils.BE_TV_SPORT_VLA_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BE_TV_SPORT_VLA_DWN_BUSINESS_ID);
        OmapiIdConstants.BE_TV_SPORT_BXL_WAL = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_LEGACY_ID, OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_DWN_BUSINESS_ID);
        OmapiIdConstants.BOUQUET_AFRICAIN = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.BOUQUET_AFRICAIN_LEGACY_ID, OmapiIdsUtils.BOUQUET_AFRICAIN_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BOUQUET_AFRICAIN_DWN_BUSINESS_ID);
        OmapiIdConstants.BOUQUET_ARABE = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.BOUQUET_ARABE_LEGACY_ID, OmapiIdsUtils.BOUQUET_ARABE_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BOUQUET_ARABE_DWN_BUSINESS_ID);
        OmapiIdConstants.DISCOVER_MORE = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.DISCOVER_MORE_LEGACY_ID, OmapiIdsUtils.DISCOVER_MORE_DWN_RESIDENTIAL_ID, OmapiIdsUtils.DISCOVER_MORE_DWN_BUSINESS_ID);
        OmapiIdConstants.FAMILY_FUN = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.FAMILY_FUN_LEGACY_ID, OmapiIdsUtils.FAMILY_FUN_DWN_RESIDENTIAL_ID, OmapiIdsUtils.FAMILY_FUN_DWN_BUSINESS_ID);
        OmapiIdConstants.OPTION_FR = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.OPTION_FR_LEGACY_ID, OmapiIdsUtils.OPTION_FR_DWN_RESIDENTIAL_ID, OmapiIdsUtils.OPTION_FR_DWN_BUSINESS_ID);
        OmapiIdConstants.PASSION_XL = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.PASSION_XL_LEGACY_ID, OmapiIdsUtils.PASSION_XL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PASSION_XL_DWN_BUSINESS_ID);
        OmapiIdConstants.STREAMZ = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.STREAMZ_LEGACY_ID, OmapiIdsUtils.STREAMZ_DWN_RESIDENTIAL_ID, OmapiIdsUtils.STREAMZ_DWN_BUSINESS_ID);
        OmapiIdConstants.STREAMZ_BASIC = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.STREAMZ_BASIC_LEGACY_ID, OmapiIdsUtils.STREAMZ_BASIC_DWN_RESIDENTIAL_ID, OmapiIdsUtils.STREAMZ_BASIC_DWN_BUSINESS_ID);
        OmapiIdConstants.PLAY_MORE = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.PLAY_MORE_LEGACY_ID, OmapiIdsUtils.PLAY_MORE_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_MORE_DWN_BUSINESS_ID);
        OmapiIdConstants.PLAY_SPORTS = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.PLAY_SPORTS_LEGACY_ID, OmapiIdsUtils.PLAY_SPORTS_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_SPORTS_DWN_BUSINESS_ID);
        OmapiIdConstants.RED_CARPET_MORE = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.RED_CARPET_MORE_LEGACY_ID, OmapiIdsUtils.RED_CARPET_MORE_DWN_RESIDENTIAL_ID, OmapiIdsUtils.RED_CARPET_MORE_DWN_BUSINESS_ID);
        OmapiIdConstants.VOO_FOOT_VLA = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.VOO_FOOT_VLA_LEGACY_ID, OmapiIdsUtils.VOO_FOOT_VLA_DWN_RESIDENTIAL_ID, OmapiIdsUtils.VOO_FOOT_VLA_DWN_BUSINESS_ID);
        OmapiIdConstants.VOO_FOOT_BXL_WAL = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.VOO_FOOT_BXL_WAL_LEGACY_ID, OmapiIdsUtils.VOO_FOOT_BXL_WAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.VOO_FOOT_BXL_WAL_DWN_BUSINESS_ID);
        OmapiIdConstants.VRT_NET_GEMIST = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.VRT_NET_GEMIST_LEGACY_ID, OmapiIdsUtils.VRT_NET_GEMIST_DWN_RESIDENTIAL_ID, OmapiIdsUtils.VRT_NET_GEMIST_DWN_BUSINESS_ID);
        OmapiIdConstants.DAY_PASS = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.DAY_PASS_LEGACY_ID, OmapiIdsUtils.DAY_PASS_DWN_RESIDENTIAL_ID, OmapiIdsUtils.DAY_PASS_DWN_BUSINESS_ID);
        OmapiIdConstants.RTL_SERIES = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.RTL_SERIES_LEGACY_ID, OmapiIdsUtils.RTL_SERIES_DWN_RESIDENTIAL_ID, OmapiIdsUtils.RTL_SERIES_DWN_BUSINESS_ID);
        OmapiIdConstants.PLAY_TRIAL = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.PLAY_TRIAL_LEGACY_ID, OmapiIdsUtils.PLAY_TRIAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_TRIAL_DWN_BUSINESS_ID);
        OmapiIdConstants.PLAY_MORE_TRIAL = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.PLAY_MORE_TRIAL_LEGACY_ID, OmapiIdsUtils.PLAY_MORE_TRIAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_MORE_TRIAL_DWN_BUSINESS_ID);
        OmapiIdConstants.PLAY_SPORTS_TRIAL = OmapiIdsUtils.getCorrectId(OmapiIdsUtils.PLAY_SPORTS_TRIAL_LEGACY_ID, OmapiIdsUtils.PLAY_SPORTS_TRIAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_SPORTS_TRIAL_DWN_BUSINESS_ID);
    };
    OmapiIdsUtils.setNameMappingConstants = function () {
        // PRODUCT NAME MAPPING
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.TRIALS, OmapiIdConstants.TRIALS);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.VOO_FOOT_VLA, OmapiIdConstants.NAME_VOO_SPORT);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.VOO_FOOT_BXL_WAL, OmapiIdConstants.NAME_VOO_SPORT);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.STREAMZ_LEGACY_ID, OmapiIdConstants.NAME_STREAMZ);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.STREAMZ_DWN_RESIDENTIAL_ID, OmapiIdConstants.NAME_STREAMZ_DWN);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.STREAMZ_DWN_BUSINESS_ID, OmapiIdConstants.NAME_STREAMZ_B2B);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.STREAMZ_BASIC_DWN_RESIDENTIAL_ID, OmapiIdConstants.NAME_STREAMZ_BASIC);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.STREAMZ_BASIC_DWN_BUSINESS_ID, OmapiIdConstants.NAME_STREAMZ_BASIC_B2B);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.PLAY_MORE, OmapiIdConstants.NAME_PLAY_MORE);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.PLAY_SPORTS, OmapiIdConstants.NAME_PLAY_SPORTS);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.DAY_PASS, OmapiIdConstants.NAME_DAY_PASS);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.RTL_SERIES, OmapiIdConstants.NAME_RTL_SERIES);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.BE_TV_VLA, OmapiIdConstants.NAME_BE_TV);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.BE_TV_BXL_WAL, OmapiIdConstants.NAME_BE_TV);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.BE_TV_SPORT_VLA, OmapiIdConstants.NAME_BE_TV_SPORT);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.BE_TV_SPORT_BXL_WAL, OmapiIdConstants.NAME_BE_TV_SPORT);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.OPTION_FR, OmapiIdConstants.NAME_OPTION_FR);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.PASSION_XL, OmapiIdConstants.NAME_PASSION_XL);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.DISCOVER_MORE, OmapiIdConstants.NAME_DISCOVER_MORE);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.FAMILY_FUN, OmapiIdConstants.NAME_FAMILY_FUN);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.BOUQUET_ARABE, OmapiIdConstants.NAME_BOUQUET_ARABE);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.BOUQUET_AFRICAIN, OmapiIdConstants.NAME_BOUQUET_AFRICAIN);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.PLAY_TRIAL, OmapiIdConstants.NAME_PLAY_TRIAL);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.PLAY_MORE_TRIAL, OmapiIdConstants.NAME_PLAY_MORE_TRIAL);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.PLAY_SPORTS_TRIAL, OmapiIdConstants.NAME_PLAY_SPORTS_TRIAL);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.VRT_NET_GEMIST, OmapiIdConstants.NAME_VRT_NET_GEMIST);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdConstants.RED_CARPET_MORE, OmapiIdConstants.NAME_RED_CARPET_MORE);
        // STREAMING SERVICES MAPPING
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_BASIC_ID, OmapiIdConstants.NAME_NETFLIX);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_STANDARD_STREAMZ_ID, OmapiIdConstants.NAME_NETFLIX_STANDARD_STREAMZ);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_STANDARD_STREAMZPLUS_ID, OmapiIdConstants.NAME_NETFLIX_STANDARD_STREAMZPLUS);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_STANDARD_PLAYMORE_ID, OmapiIdConstants.NAME_NETFLIX_STANDARD_PLAYMORE);
        // STREAMING BUNDLES
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_BASIC_ID, OmapiIdConstants.NAME_NETFLIX_BASIC_ID);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.DISNEY_PLUS_ID, OmapiIdConstants.NAME_DISNEY_PLUS);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_STANDALONE_ID, OmapiIdConstants.NAME_NETFLIX_STANDALONE_ID);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_STANDARD_ID, OmapiIdConstants.NAME_NETFLIX_STANDARD_ID);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_PREMIUM_ID, OmapiIdConstants.NAME_NETFLIX_PREMIUM_ID);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_STANDARD_STREAMZ_ID, OmapiIdConstants.NAME_NETFLIX_STANDARD_STREAMZ_ID);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_STANDARD_STREAMZPLUS_ID, OmapiIdConstants.NAME_NETFLIX_STANDARD_STREAMZPLUS_ID);
        OmapiIdConstants.PRODUCT_NAME_MAP.set(OmapiIdsUtils.NETFLIX_STANDARD_PLAYMORE_ID, OmapiIdConstants.NAME_NETFLIX_STANDARD_PLAYMORE_ID);
        // PRODUCT TRIAL MAPPING
        OmapiIdConstants.PRODUCT_TRIAL_MAP.set(OmapiIdConstants.DAY_PASS, OmapiIdConstants.PLAY_SPORTS);
        OmapiIdConstants.PRODUCT_TRIAL_MAP.set(OmapiIdConstants.PLAY_SPORTS_TRIAL, OmapiIdConstants.PLAY_SPORTS);
        OmapiIdConstants.PRODUCT_TRIAL_MAP.set(OmapiIdConstants.PLAY_TRIAL, OmapiIdConstants.STREAMZ);
        OmapiIdConstants.PRODUCT_TRIAL_MAP.set(OmapiIdConstants.PLAY_MORE_TRIAL, OmapiIdConstants.PLAY_MORE);
        OmapiIdConstants.PRODUCT_TRIAL_MAP.set(OmapiIdConstants.PLAY_MORE, OmapiIdConstants.PLAY_MORE_TRIAL);
        OmapiIdConstants.PRODUCT_TRIAL_MAP.set(OmapiIdConstants.STREAMZ, OmapiIdConstants.PLAY_TRIAL);
        OmapiIdConstants.PRODUCT_TRIAL_MAP.set(OmapiIdConstants.PLAY_SPORTS, OmapiIdConstants.PLAY_SPORTS_TRIAL);
        // LABEL TRIAL MAPPING
        LabelConstants.LABEL_TRIAL_MAP.set(LabelConstants.TRIAL_PLAY_SPORTS_LABEL_FALL_BACK, OmapiIdConstants.PLAY_SPORTS_TRIAL);
        LabelConstants.LABEL_TRIAL_MAP.set(LabelConstants.TRIAL_PLAY_SPORTS_LABEL, OmapiIdConstants.PLAY_SPORTS_TRIAL);
        LabelConstants.LABEL_TRIAL_MAP.set(LabelConstants.TRIAL_PLAY_30_DAYS_LABEL, OmapiIdConstants.PLAY_TRIAL);
        LabelConstants.LABEL_TRIAL_MAP.set(LabelConstants.TRIAL_PLAY_75_DAYS_LABEL, OmapiIdConstants.PLAY_TRIAL);
        LabelConstants.LABEL_TRIAL_MAP.set(LabelConstants.TRIAL_PLAY_MORE_30_DAYS_LABEL, OmapiIdConstants.PLAY_MORE_TRIAL);
        LabelConstants.LABEL_TRIAL_MAP.set(LabelConstants.TRIAL_PLAY_MORE_75_DAYS_LABEL, OmapiIdConstants.PLAY_MORE_TRIAL);
    };
    OmapiIdsUtils.getCorrectId = function (legacyId, dwnResidentialId, dwnBusinessId) {
        if (OmapiIdsUtils.isLegacyUser()) {
            return legacyId;
        }
        else if (OmapiIdsUtils.isDwnUser()) {
            if (OmapiIdsUtils.isResidentialUser()) {
                return dwnResidentialId;
            }
            else if (OmapiIdsUtils.isBusinessUser()) {
                return dwnBusinessId;
            }
        }
        return null;
    };
    OmapiIdsUtils.getCorrectIdForResource = function (omapiId) {
        if (omapiId && omapiId === OmapiIdsUtils.NETFLIX_STANDALONE) {
            return omapiId;
        }
        if (omapiId && (omapiId.startsWith(OmapiIdsUtils.STRM_ID))) {
            return omapiId;
        }
        if (OmapiIdsUtils.isLegacyUser()) {
            return omapiId;
        }
        else if (OmapiIdsUtils.isDwnUser()) {
            if (OmapiIdsUtils.isResidentialUser()) {
                return OmapiIdsUtils.DWN_RESIDENTIAL_TO_LEGACY_MAPPING.get(omapiId);
            }
            else if (OmapiIdsUtils.isBusinessUser()) {
                return OmapiIdsUtils.DWN_BUSINESS_TO_LEGACY_MAPPING.get(omapiId);
            }
        }
        return null;
    };
    OmapiIdsUtils.isLegacyUser = function () {
        return OmapiIdsUtils.currentUserType === UserTypeConstants.LEGACY_USER;
    };
    OmapiIdsUtils.isDwnUser = function () {
        return OmapiIdsUtils.currentUserType === UserTypeConstants.DWN_USER;
    };
    OmapiIdsUtils.isResidentialUser = function () {
        return OmapiIdsUtils.currentDarwinUserType === UserTypeConstants.RESIDENTIAL_USER;
    };
    OmapiIdsUtils.isBusinessUser = function () {
        return OmapiIdsUtils.currentDarwinUserType === UserTypeConstants.BUSINESS_USER;
    };
    OmapiIdsUtils.parseJwt = function (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    };
    OmapiIdsUtils._BSS_SYSTEM_FLAG = 'http://telenet.be/claims/bss_system';
    // LEGACY IDS
    OmapiIdsUtils.TRIALS_LEGACY_ID = 'trials';
    OmapiIdsUtils.STREAMZ_LEGACY_ID = '585';
    OmapiIdsUtils.PLAY_MORE_LEGACY_ID = '586';
    OmapiIdsUtils.STREAMZ_BASIC_LEGACY_ID = 'TVPK0023';
    OmapiIdsUtils.PLAY_SPORTS_LEGACY_ID = '275';
    OmapiIdsUtils.DAY_PASS_LEGACY_ID = '10452';
    OmapiIdsUtils.OPTION_FR_LEGACY_ID = '416';
    OmapiIdsUtils.PASSION_XL_LEGACY_ID = '291';
    OmapiIdsUtils.DISCOVER_MORE_LEGACY_ID = '15583';
    OmapiIdsUtils.FAMILY_FUN_LEGACY_ID = '15584';
    OmapiIdsUtils.BOUQUET_ARABE_LEGACY_ID = '15585';
    OmapiIdsUtils.BOUQUET_AFRICAIN_LEGACY_ID = '15586';
    OmapiIdsUtils.VRT_NET_GEMIST_LEGACY_ID = '293';
    OmapiIdsUtils.RED_CARPET_MORE_LEGACY_ID = '35824'; // STREAMZ PREMIUM PLUS
    OmapiIdsUtils.BE_TV_VLA_LEGACY_ID = '278';
    OmapiIdsUtils.BE_TV_SPORT_VLA_LEGACY_ID = '600';
    OmapiIdsUtils.VOO_FOOT_VLA_LEGACY_ID = '619';
    OmapiIdsUtils.BE_TV_BXL_WAL_LEGACY_ID = '431';
    OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_LEGACY_ID = '598';
    OmapiIdsUtils.VOO_FOOT_BXL_WAL_LEGACY_ID = '618';
    OmapiIdsUtils.PLAY_TRIAL_LEGACY_ID = '622';
    OmapiIdsUtils.PLAY_MORE_TRIAL_LEGACY_ID = '623';
    OmapiIdsUtils.PLAY_SPORTS_TRIAL_LEGACY_ID = '624';
    OmapiIdsUtils.RTL_SERIES_LEGACY_ID = '587';
    // DWN IDS RESIDENTIAL
    OmapiIdsUtils.TRIALS_DWN_RESIDENTIAL_ID = 'trials';
    OmapiIdsUtils.STREAMZ_DWN_RESIDENTIAL_ID = 'TVPK0014';
    OmapiIdsUtils.PLAY_MORE_DWN_RESIDENTIAL_ID = 'TVPK0015';
    OmapiIdsUtils.PLAY_SPORTS_DWN_RESIDENTIAL_ID = 'TVPK0016';
    OmapiIdsUtils.STREAMZ_BASIC_DWN_RESIDENTIAL_ID = 'TVPK0023';
    OmapiIdsUtils.DAY_PASS_DWN_RESIDENTIAL_ID = 'TVPK0107';
    OmapiIdsUtils.OPTION_FR_DWN_RESIDENTIAL_ID = 'TVPK0012';
    OmapiIdsUtils.PASSION_XL_DWN_RESIDENTIAL_ID = 'TVPK0013';
    OmapiIdsUtils.DISCOVER_MORE_DWN_RESIDENTIAL_ID = 'TVPK0010';
    OmapiIdsUtils.FAMILY_FUN_DWN_RESIDENTIAL_ID = 'TVPK0011';
    OmapiIdsUtils.BOUQUET_ARABE_DWN_RESIDENTIAL_ID = 'TVPK0009';
    OmapiIdsUtils.BOUQUET_AFRICAIN_DWN_RESIDENTIAL_ID = 'TVPK0008';
    OmapiIdsUtils.VRT_NET_GEMIST_DWN_RESIDENTIAL_ID = 'TVPK0021';
    OmapiIdsUtils.RED_CARPET_MORE_DWN_RESIDENTIAL_ID = 'TVPK0018';
    OmapiIdsUtils.BE_TV_VLA_DWN_RESIDENTIAL_ID = 'TVPK0005';
    OmapiIdsUtils.BE_TV_SPORT_VLA_DWN_RESIDENTIAL_ID = 'TVPK0006';
    OmapiIdsUtils.VOO_FOOT_VLA_DWN_RESIDENTIAL_ID = 'TVPK0020';
    OmapiIdsUtils.BE_TV_BXL_WAL_DWN_RESIDENTIAL_ID = 'TVPK0005';
    OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_DWN_RESIDENTIAL_ID = 'TVPK0006';
    OmapiIdsUtils.VOO_FOOT_BXL_WAL_DWN_RESIDENTIAL_ID = 'TVPK0020';
    OmapiIdsUtils.PLAY_TRIAL_DWN_RESIDENTIAL_ID = 'TVPK0102';
    OmapiIdsUtils.PLAY_MORE_TRIAL_DWN_RESIDENTIAL_ID = 'TVPK0104';
    OmapiIdsUtils.PLAY_SPORTS_TRIAL_DWN_RESIDENTIAL_ID = 'TVPK0106';
    OmapiIdsUtils.RTL_SERIES_DWN_RESIDENTIAL_ID = 'XXXXX'; // not needed for dwn business
    // DWN IDS BUSINESS
    OmapiIdsUtils.TRIALS_DWN_BUSINESS_ID = 'trials';
    OmapiIdsUtils.STREAMZ_DWN_BUSINESS_ID = 'TVPK1015';
    OmapiIdsUtils.PLAY_MORE_DWN_BUSINESS_ID = 'TVPK1016';
    OmapiIdsUtils.PLAY_SPORTS_DWN_BUSINESS_ID = 'TVPK1017';
    OmapiIdsUtils.STREAMZ_BASIC_DWN_BUSINESS_ID = 'TVPK1024';
    OmapiIdsUtils.DAY_PASS_DWN_BUSINESS_ID = 'TVPK1107';
    OmapiIdsUtils.OPTION_FR_DWN_BUSINESS_ID = 'TVPK1013';
    OmapiIdsUtils.PASSION_XL_DWN_BUSINESS_ID = 'TVPK1014';
    OmapiIdsUtils.DISCOVER_MORE_DWN_BUSINESS_ID = 'TVPK1011';
    OmapiIdsUtils.FAMILY_FUN_DWN_BUSINESS_ID = 'TVPK1012';
    OmapiIdsUtils.BOUQUET_ARABE_DWN_BUSINESS_ID = 'TVPK1010';
    OmapiIdsUtils.BOUQUET_AFRICAIN_DWN_BUSINESS_ID = 'TVPK1009';
    OmapiIdsUtils.VRT_NET_GEMIST_DWN_BUSINESS_ID = 'XXXXX'; // not needed for dwn business
    OmapiIdsUtils.RED_CARPET_MORE_DWN_BUSINESS_ID = 'TVPK1019';
    OmapiIdsUtils.BE_TV_VLA_DWN_BUSINESS_ID = 'TVPK1005';
    OmapiIdsUtils.BE_TV_SPORT_VLA_DWN_BUSINESS_ID = 'TVPK1008';
    OmapiIdsUtils.VOO_FOOT_VLA_DWN_BUSINESS_ID = 'TVPK1021';
    OmapiIdsUtils.BE_TV_BXL_WAL_DWN_BUSINESS_ID = 'TVPK1005';
    OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_DWN_BUSINESS_ID = 'TVPK1008';
    OmapiIdsUtils.VOO_FOOT_BXL_WAL_DWN_BUSINESS_ID = 'TVPK1021';
    OmapiIdsUtils.PLAY_TRIAL_DWN_BUSINESS_ID = 'TVPK1104';
    OmapiIdsUtils.PLAY_MORE_TRIAL_DWN_BUSINESS_ID = 'TVPK0108';
    OmapiIdsUtils.PLAY_SPORTS_TRIAL_DWN_BUSINESS_ID = 'XXXXX'; // does not exist for dwn business
    OmapiIdsUtils.RTL_SERIES_DWN_BUSINESS_ID = 'XXXXX'; // not needed for dwn business
    // STREAMING SERVICES IDS
    OmapiIdsUtils.STRM_ID = 'STRM';
    OmapiIdsUtils.STREAMING_BUNDLE = 'STRM0001';
    OmapiIdsUtils.NETFLIX_BASIC_ID = 'STRM0004';
    OmapiIdsUtils.NETFLIX_STANDALONE_ID = 'netflix-standalone';
    OmapiIdsUtils.NETFLIX_STANDARD_ID = 'STRM0005';
    OmapiIdsUtils.NETFLIX_PREMIUM_ID = 'STRM0007';
    OmapiIdsUtils.NETFLIX_STANDARD_STREAMZ_ID = 'STRM0008';
    OmapiIdsUtils.NETFLIX_STANDARD_STREAMZPLUS_ID = 'STRM0009';
    OmapiIdsUtils.NETFLIX_STANDARD_PLAYMORE_ID = 'STRM0010';
    OmapiIdsUtils.DISNEY_PLUS_STANDALONE_ID = 'disney-standalone';
    OmapiIdsUtils.DISNEY_PLUS_ID = 'STRM0002';
    OmapiIdsUtils.NETFLIX_STANDALONE = 'netflix-standalone';
    OmapiIdsUtils.NETFLIX_STANDALONE_PRODUCTS = [
        OmapiIdsUtils.NETFLIX_BASIC_ID,
        OmapiIdsUtils.NETFLIX_STANDARD_ID,
        OmapiIdsUtils.NETFLIX_PREMIUM_ID
    ];
    OmapiIdsUtils.DISNEY_STANDALONE_PRODUCTS = [
        OmapiIdsUtils.DISNEY_PLUS_ID
    ];
    OmapiIdsUtils.NETFLIX_STANDARD_BUNDLES = [
        OmapiIdsUtils.NETFLIX_STANDARD_STREAMZ_ID,
        OmapiIdsUtils.NETFLIX_STANDARD_STREAMZPLUS_ID,
        OmapiIdsUtils.NETFLIX_STANDARD_PLAYMORE_ID
    ];
    OmapiIdsUtils.NETFLIX_FAQS_PACKS = [
        OmapiIdsUtils.NETFLIX_STANDALONE,
        OmapiIdsUtils.NETFLIX_STANDARD_STREAMZ_ID,
        OmapiIdsUtils.NETFLIX_STANDARD_STREAMZPLUS_ID,
        OmapiIdsUtils.NETFLIX_STANDARD_PLAYMORE_ID
    ];
    OmapiIdsUtils.STREAMZ_PACKS_GROUP = [];
    OmapiIdsUtils.STREAMZ_FREE_ADD_PACKS_GROUP = [];
    OmapiIdsUtils.ORDER_PACK = [];
    OmapiIdsUtils.DWN_RESIDENTIAL_TO_LEGACY_MAPPING = new Map([
        [OmapiIdsUtils.TRIALS_DWN_RESIDENTIAL_ID, OmapiIdsUtils.TRIALS_LEGACY_ID],
        [OmapiIdsUtils.STREAMZ_DWN_RESIDENTIAL_ID, OmapiIdsUtils.STREAMZ_LEGACY_ID],
        [OmapiIdsUtils.STREAMZ_BASIC_DWN_RESIDENTIAL_ID, OmapiIdsUtils.STREAMZ_BASIC_LEGACY_ID],
        [OmapiIdsUtils.PLAY_MORE_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_MORE_LEGACY_ID],
        [OmapiIdsUtils.PLAY_SPORTS_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_SPORTS_LEGACY_ID],
        [OmapiIdsUtils.DAY_PASS_DWN_RESIDENTIAL_ID, OmapiIdsUtils.DAY_PASS_LEGACY_ID],
        [OmapiIdsUtils.OPTION_FR_DWN_RESIDENTIAL_ID, OmapiIdsUtils.OPTION_FR_LEGACY_ID],
        [OmapiIdsUtils.PASSION_XL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PASSION_XL_LEGACY_ID],
        [OmapiIdsUtils.DISCOVER_MORE_DWN_RESIDENTIAL_ID, OmapiIdsUtils.DISCOVER_MORE_LEGACY_ID],
        [OmapiIdsUtils.FAMILY_FUN_DWN_RESIDENTIAL_ID, OmapiIdsUtils.FAMILY_FUN_LEGACY_ID],
        [OmapiIdsUtils.BOUQUET_ARABE_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BOUQUET_ARABE_LEGACY_ID],
        [OmapiIdsUtils.BOUQUET_AFRICAIN_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BOUQUET_AFRICAIN_LEGACY_ID],
        [OmapiIdsUtils.VRT_NET_GEMIST_DWN_RESIDENTIAL_ID, OmapiIdsUtils.VRT_NET_GEMIST_LEGACY_ID],
        [OmapiIdsUtils.RED_CARPET_MORE_DWN_RESIDENTIAL_ID, OmapiIdsUtils.RED_CARPET_MORE_LEGACY_ID],
        [OmapiIdsUtils.BE_TV_VLA_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BE_TV_VLA_LEGACY_ID],
        [OmapiIdsUtils.BE_TV_SPORT_VLA_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BE_TV_SPORT_VLA_LEGACY_ID],
        [OmapiIdsUtils.VOO_FOOT_VLA_DWN_RESIDENTIAL_ID, OmapiIdsUtils.VOO_FOOT_VLA_LEGACY_ID],
        [OmapiIdsUtils.BE_TV_BXL_WAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BE_TV_BXL_WAL_LEGACY_ID],
        [OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_LEGACY_ID],
        [OmapiIdsUtils.VOO_FOOT_BXL_WAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.VOO_FOOT_BXL_WAL_LEGACY_ID],
        [OmapiIdsUtils.RTL_SERIES_DWN_RESIDENTIAL_ID, OmapiIdsUtils.RTL_SERIES_LEGACY_ID],
        [OmapiIdsUtils.PLAY_TRIAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_TRIAL_LEGACY_ID],
        [OmapiIdsUtils.PLAY_MORE_TRIAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_MORE_TRIAL_LEGACY_ID],
        [OmapiIdsUtils.PLAY_SPORTS_TRIAL_DWN_RESIDENTIAL_ID, OmapiIdsUtils.PLAY_SPORTS_TRIAL_LEGACY_ID]
    ]);
    OmapiIdsUtils.DWN_BUSINESS_TO_LEGACY_MAPPING = new Map([
        [OmapiIdsUtils.TRIALS_DWN_BUSINESS_ID, OmapiIdsUtils.TRIALS_LEGACY_ID],
        [OmapiIdsUtils.STREAMZ_DWN_BUSINESS_ID, OmapiIdsUtils.STREAMZ_LEGACY_ID],
        [OmapiIdsUtils.PLAY_MORE_DWN_BUSINESS_ID, OmapiIdsUtils.PLAY_MORE_LEGACY_ID],
        [OmapiIdsUtils.PLAY_SPORTS_DWN_BUSINESS_ID, OmapiIdsUtils.PLAY_SPORTS_LEGACY_ID],
        [OmapiIdsUtils.STREAMZ_BASIC_DWN_BUSINESS_ID, OmapiIdsUtils.STREAMZ_BASIC_LEGACY_ID],
        [OmapiIdsUtils.DAY_PASS_DWN_BUSINESS_ID, OmapiIdsUtils.DAY_PASS_LEGACY_ID],
        [OmapiIdsUtils.OPTION_FR_DWN_BUSINESS_ID, OmapiIdsUtils.OPTION_FR_LEGACY_ID],
        [OmapiIdsUtils.PASSION_XL_DWN_BUSINESS_ID, OmapiIdsUtils.PASSION_XL_LEGACY_ID],
        [OmapiIdsUtils.DISCOVER_MORE_DWN_BUSINESS_ID, OmapiIdsUtils.DISCOVER_MORE_LEGACY_ID],
        [OmapiIdsUtils.FAMILY_FUN_DWN_BUSINESS_ID, OmapiIdsUtils.FAMILY_FUN_LEGACY_ID],
        [OmapiIdsUtils.BOUQUET_ARABE_DWN_BUSINESS_ID, OmapiIdsUtils.BOUQUET_ARABE_LEGACY_ID],
        [OmapiIdsUtils.BOUQUET_AFRICAIN_DWN_BUSINESS_ID, OmapiIdsUtils.BOUQUET_AFRICAIN_LEGACY_ID],
        [OmapiIdsUtils.VRT_NET_GEMIST_DWN_BUSINESS_ID, OmapiIdsUtils.VRT_NET_GEMIST_LEGACY_ID],
        [OmapiIdsUtils.RED_CARPET_MORE_DWN_BUSINESS_ID, OmapiIdsUtils.RED_CARPET_MORE_LEGACY_ID],
        [OmapiIdsUtils.BE_TV_VLA_DWN_BUSINESS_ID, OmapiIdsUtils.BE_TV_VLA_LEGACY_ID],
        [OmapiIdsUtils.BE_TV_SPORT_VLA_DWN_BUSINESS_ID, OmapiIdsUtils.BE_TV_SPORT_VLA_LEGACY_ID],
        [OmapiIdsUtils.VOO_FOOT_VLA_DWN_BUSINESS_ID, OmapiIdsUtils.VOO_FOOT_VLA_LEGACY_ID],
        [OmapiIdsUtils.BE_TV_BXL_WAL_DWN_BUSINESS_ID, OmapiIdsUtils.BE_TV_BXL_WAL_LEGACY_ID],
        [OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_DWN_BUSINESS_ID, OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_LEGACY_ID],
        [OmapiIdsUtils.VOO_FOOT_BXL_WAL_DWN_BUSINESS_ID, OmapiIdsUtils.VOO_FOOT_BXL_WAL_LEGACY_ID],
        [OmapiIdsUtils.RTL_SERIES_DWN_BUSINESS_ID, OmapiIdsUtils.RTL_SERIES_LEGACY_ID],
        [OmapiIdsUtils.PLAY_TRIAL_DWN_BUSINESS_ID, OmapiIdsUtils.PLAY_TRIAL_LEGACY_ID],
        [OmapiIdsUtils.PLAY_MORE_TRIAL_DWN_BUSINESS_ID, OmapiIdsUtils.PLAY_MORE_TRIAL_LEGACY_ID],
        [OmapiIdsUtils.PLAY_SPORTS_TRIAL_DWN_BUSINESS_ID, OmapiIdsUtils.PLAY_SPORTS_TRIAL_LEGACY_ID]
    ]);
    OmapiIdsUtils.OrderPacks = [
        OmapiIdsUtils.STREAMZ_BASIC_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.STREAMZ_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.RED_CARPET_MORE_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.PLAY_MORE_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.PLAY_SPORTS_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.PLAY_TRIAL_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.PLAY_MORE_TRIAL_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.PLAY_SPORTS_TRIAL_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.DAY_PASS_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.TRIALS_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.OPTION_FR_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.PASSION_XL_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.DISCOVER_MORE_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.FAMILY_FUN_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.BOUQUET_ARABE_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.BOUQUET_AFRICAIN_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.VRT_NET_GEMIST_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.BE_TV_VLA_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.BE_TV_SPORT_VLA_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.VOO_FOOT_VLA_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.BE_TV_BXL_WAL_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.VOO_FOOT_BXL_WAL_DWN_RESIDENTIAL_ID,
        OmapiIdsUtils.RTL_SERIES_DWN_RESIDENTIAL_ID,
    ];
    OmapiIdsUtils.OrderPacksBusiness = [
        OmapiIdsUtils.STREAMZ_BASIC_DWN_BUSINESS_ID,
        OmapiIdsUtils.STREAMZ_DWN_BUSINESS_ID,
        OmapiIdsUtils.RED_CARPET_MORE_DWN_BUSINESS_ID,
        OmapiIdsUtils.PLAY_MORE_DWN_BUSINESS_ID,
        OmapiIdsUtils.PLAY_SPORTS_DWN_BUSINESS_ID,
        OmapiIdsUtils.PLAY_TRIAL_DWN_BUSINESS_ID,
        OmapiIdsUtils.PLAY_MORE_TRIAL_DWN_BUSINESS_ID,
        OmapiIdsUtils.PLAY_SPORTS_TRIAL_DWN_BUSINESS_ID,
        OmapiIdsUtils.DAY_PASS_DWN_BUSINESS_ID,
        OmapiIdsUtils.TRIALS_DWN_BUSINESS_ID,
        OmapiIdsUtils.OPTION_FR_DWN_BUSINESS_ID,
        OmapiIdsUtils.PASSION_XL_DWN_BUSINESS_ID,
        OmapiIdsUtils.DISCOVER_MORE_DWN_BUSINESS_ID,
        OmapiIdsUtils.FAMILY_FUN_DWN_BUSINESS_ID,
        OmapiIdsUtils.BOUQUET_ARABE_DWN_BUSINESS_ID,
        OmapiIdsUtils.BOUQUET_AFRICAIN_DWN_BUSINESS_ID,
        OmapiIdsUtils.VRT_NET_GEMIST_DWN_BUSINESS_ID,
        OmapiIdsUtils.BE_TV_VLA_DWN_BUSINESS_ID,
        OmapiIdsUtils.BE_TV_SPORT_VLA_DWN_BUSINESS_ID,
        OmapiIdsUtils.VOO_FOOT_VLA_DWN_BUSINESS_ID,
        OmapiIdsUtils.BE_TV_BXL_WAL_DWN_BUSINESS_ID,
        OmapiIdsUtils.BE_TV_SPORT_BXL_WAL_DWN_BUSINESS_ID,
        OmapiIdsUtils.VOO_FOOT_BXL_WAL_DWN_BUSINESS_ID,
        OmapiIdsUtils.RTL_SERIES_DWN_BUSINESS_ID,
    ];
    return OmapiIdsUtils;
}());
export { OmapiIdsUtils };
